module.exports = __webpack_public_path__ + "static/media/icon_chart.f5989eda.png";